/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurehistorytitle2Inputs */

const he_extension_featurehistorytitle2 = /** @type {(inputs: Extension_Featurehistorytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היסטוריה מלאה`)
};

const en_extension_featurehistorytitle2 = /** @type {(inputs: Extension_Featurehistorytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full History`)
};

/**
* | output |
* | --- |
* | "Full History" |
*
* @param {Extension_Featurehistorytitle2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurehistorytitle2 = /** @type {((inputs?: Extension_Featurehistorytitle2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurehistorytitle2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurehistorytitle2(inputs)
	return en_extension_featurehistorytitle2(inputs)
});
export { extension_featurehistorytitle2 as "extension_featureHistoryTitle" }